var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabIconResources(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.32,
    height: 33.519,
    viewBox: "0 0 27.32 33.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resurser",
    transform: "translate(0.863 0.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24324",
    "data-name": "Path 24324",
    d: "M-65.43,9.4l14.366-4.516,10.448,4.625-12.57,4.516Z",
    transform: "translate(65.904 -1.157)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24325",
    "data-name": "Path 24325",
    d: "M-65.43,12.585v16.6a1.517,1.517,0,0,0,.894,1.383l10.59,4.771a1.518,1.518,0,0,0,1.2.02l11.291-4.641a1.516,1.516,0,0,0,.94-1.412l-.1-16.607",
    transform: "translate(65.904 -3.678)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1049",
    "data-name": "Line 1049",
    y1: 18.24,
    transform: "translate(12.716 13.535)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1050",
    "data-name": "Line 1050",
    y2: 8.38,
    transform: "translate(14.84 3.727)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24326",
    "data-name": "Path 24326",
    d: "M-24.9,9.659l-.543-2.882a.737.737,0,0,1,.724-.873h0a.737.737,0,0,1,.734.8l-.235,2.9",
    transform: "translate(49.372 -1.578)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24327",
    "data-name": "Path 24327",
    d: "M-41.975,2.282-42.517-.6a.736.736,0,0,1,.724-.873h0a.737.737,0,0,1,.734.8l-.235,2.9",
    transform: "translate(56.433 1.472)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24328",
    "data-name": "Path 24328",
    d: "M-65.683,9.752l-.542-2.882A.736.736,0,0,1-65.5,6h0a.736.736,0,0,1,.734.8L-65,9.7",
    transform: "translate(66.238 -1.617)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24329",
    "data-name": "Path 24329",
    d: "M-45.965,17.314l-.542-2.882a.736.736,0,0,1,.724-.873h0a.736.736,0,0,1,.734.8l-.235,2.9",
    transform: "translate(58.083 -4.531)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1051",
    "data-name": "Line 1051",
    x1: 3.836,
    y2: 1.279,
    transform: "translate(21.533 19.385)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1052",
    "data-name": "Line 1052",
    x1: 5.088,
    y2: 1.768,
    transform: "translate(20.254 21.729)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1053",
    "data-name": "Line 1053",
    x1: 6.611,
    y2: 2.34,
    transform: "translate(18.73 23.965)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconResources);
export default __webpack_public_path__ + "static/media/TabIcon_Resources.b783378d9c0776b9b3ac92fb3aae9779.svg";
export { ForwardRef as ReactComponent };